<template>

    <div class="d-flex justify-content-between align-items-center flex-wrap">
        <div class="d-flex flex-wrap mr-3">
            <router-link :to="{ name: route_link, params: {page: 1}}" :class="{ disabled: !paginate.prev_page_url }" class="btn btn-icon btn-sm btn-light-primary mr-2 my-1"><i class="ki ki-bold-double-arrow-back icon-xs"></i></router-link>
            <router-link :to="{ name: route_link, params: {page: paginate.current_page - 2}}" v-if="(paginate.current_page - 2) > 0" class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">{{ paginate.current_page - 2 }}</router-link>
            <router-link :to="{ name: route_link, params: {page: paginate.current_page - 1}}" v-if="paginate.prev_page_url" class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">{{ paginate.current_page - 1 }}</router-link>
            <a class="btn btn-icon btn-sm border-0 btn-hover-primary active mr-2 my-1">{{ paginate.current_page }}</a>
            <router-link :to="{ name: route_link, params: {page: paginate.current_page + 1}}" v-if="paginate.next_page_url" class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">{{ paginate.current_page + 1 }}</router-link>
            <router-link :to="{ name: route_link, params: {page: paginate.current_page + 2}}" v-if="(paginate.current_page + 2) <= paginate.last_page" class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">{{ paginate.current_page + 2 }}</router-link>
            <router-link :to="{ name: route_link, params: {page: paginate.last_page}}" :class="{ disabled: !paginate.next_page_url }" class="btn btn-icon btn-sm btn-light-primary mr-2 my-1"><i class="ki ki-bold-double-arrow-next icon-xs"></i></router-link>
        </div>
        <span class="text-muted"></span>
        <div class="d-flex align-items-center">
            <select v-model="filter.to" class="form-control form-control-sm text-primary font-weight-bold mr-4 border-0 bg-light-primary" style="width: 75px;">
                <option value="10">10</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
            </select>
            <span class="text-muted">{{  paginate.to }} из {{  paginate.total }}</span>
        </div>
    </div>


</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: "Paginate",
        props: [ 'route_link', 'filter'],
        computed: {
            ...mapState({
                paginate: state => state.paginate.paginate,
            }),
        }

    }
</script>

<style scoped>

</style>